<div class="form-container edp-form delete-account">
    <form [formGroup]="form">
        <div class="input-container pb-0">
            <div class="form-group" >
                <label class="form-check-label" *ngFor="let item of types">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        [checked]="item.selected"
                        (change)="setTypeDelete(item.id, item.type)"
                    />
                    <span class="form-check-mark"></span>
                    <span class="form-check-name">{{ item.type }}</span>
                </label>

            </div>
        </div>
    </form>
</div>
